var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5AA587"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M288.243,325.611c15.106,3.611,31.231,3.892,47.355-0.111c28.408-7.054,50.878-25.575,63.937-49.356   c-22.666-14.912-51.19-20.771-79.598-13.717c-15.273,3.792-28.671,11.063-39.962,20.528c0.106-0.142,0.196-0.282,0.301-0.423   c41.833-37.724,88.533-25.544,88.533-25.544l11.049-9.44c0,0-47.105-16.274-89.298,18.627c26.113-50.557-2.064-93.927-2.064-93.927   l-6.499,12.998c0,0,23.434,42.973-3.981,93.11c-0.033,0.036-0.064,0.077-0.097,0.113c6.681-13.42,10.577-28.462,10.577-44.482   c0-29.27-12.56-55.542-32.494-73.947c-19.934,18.405-32.494,44.676-32.494,73.947c0,16.02,3.896,31.062,10.577,44.482   c-0.033-0.037-0.064-0.077-0.097-0.113c-27.415-50.137-3.981-93.11-3.981-93.11l-6.499-12.998c0,0-28.177,43.369-2.064,93.927   c-42.193-34.901-89.298-18.627-89.298-18.627l11.049,9.44c0,0,46.7-12.18,88.533,25.544c0.106,0.141,0.195,0.281,0.301,0.423   c-11.292-9.465-24.69-16.736-39.962-20.528c-28.408-7.053-56.932-1.194-79.598,13.717c13.058,23.782,35.529,42.303,63.937,49.356   c16.124,4.003,32.248,3.722,47.355,0.111c-56.283,15.736-93.094-18.164-93.094-18.164l-14.181,3.175   c0,0,56.883,60.998,139.518,1.161c82.634,59.837,139.518-1.161,139.518-1.161l-14.181-3.175   C381.337,307.447,344.526,341.347,288.243,325.611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M173.874,395.825c5.873,3.646,12.013,6.896,18.372,9.748h127.507   c6.359-2.853,12.499-6.103,18.372-9.748H173.874z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M203.67,410.181c16.361,5.827,33.969,9.025,52.33,9.025s35.969-3.198,52.33-9.025H203.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M139.302,366.669c1.968,2.219,3.981,4.396,6.071,6.499h221.255c2.09-2.103,4.103-4.28,6.071-6.499   H139.302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M153.563,380.797c3.256,2.839,6.616,5.559,10.101,8.124h184.672   c3.485-2.565,6.846-5.284,10.101-8.124H153.563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M320.989,349.343c-36.398,0-61.301-24.326-61.549-24.574l-3.449-3.427l-3.437,3.434   c-0.248,0.247-24.99,24.568-61.543,24.568h-65.049c2.221,3.347,4.58,6.59,7.045,9.748h58.004c32.697,0,56.437-17.104,64.989-24.314   c8.552,7.21,32.291,24.314,64.989,24.314h58.004c2.465-3.159,4.825-6.402,7.045-9.748L320.989,349.343L320.989,349.343z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M254.294,94.024l-5.703,17.099l-18.025,0.14c-1.729,0.013-2.445,2.219-1.055,3.246l14.5,10.708   l-5.437,17.186c-0.521,1.648,1.355,3.011,2.761,2.006L256,133.927l14.665,10.482c1.406,1.005,3.283-0.358,2.761-2.006   l-5.437-17.186l14.5-10.708c1.391-1.027,0.674-3.233-1.055-3.246l-18.025-0.14l-5.703-17.099   C257.16,92.384,254.84,92.384,254.294,94.024z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M168.99,129.024l3.301,11.989l-10.274,7.004c-0.985,0.672-0.549,2.211,0.643,2.265l12.422,0.565   l3.487,11.936c0.334,1.145,1.933,1.205,2.353,0.089l4.376-11.639l12.429,0.372c1.192,0.036,1.743-1.466,0.812-2.21l-9.717-7.759   l4.195-11.706c0.402-1.123-0.856-2.111-1.851-1.455l-10.382,6.844l-9.837-7.607C170.002,126.984,168.673,127.875,168.99,129.024z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M119.257,189.407l8.991,8.59l-5.217,11.288c-0.5,1.082,0.665,2.179,1.715,1.613l10.948-5.897   l9.123,8.449c0.875,0.81,2.278,0.041,2.064-1.133l-2.225-12.234l10.855-6.066c1.041-0.582,0.742-2.154-0.439-2.313l-12.323-1.664   l-2.414-12.198c-0.232-1.17-1.819-1.372-2.336-0.297l-5.391,11.206l-12.347-1.473C119.077,187.136,118.395,188.583,119.257,189.407   z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M345.838,129.024l-3.301,11.989l10.275,7.004c0.985,0.672,0.549,2.211-0.643,2.265l-12.422,0.565   l-3.487,11.936c-0.334,1.145-1.933,1.205-2.353,0.089l-4.376-11.639l-12.429,0.372c-1.192,0.036-1.743-1.466-0.811-2.21   l9.717-7.759l-4.195-11.706c-0.402-1.123,0.856-2.111,1.851-1.455l10.382,6.844l9.837-7.607   C344.825,126.984,346.154,127.875,345.838,129.024z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M395.571,189.407l-8.991,8.59l5.217,11.288c0.5,1.082-0.665,2.179-1.715,1.613l-10.948-5.897   l-9.123,8.449c-0.875,0.81-2.278,0.041-2.064-1.133l2.225-12.234l-10.855-6.066c-1.041-0.582-0.742-2.154,0.439-2.313l12.323-1.664   l2.414-12.198c0.232-1.17,1.819-1.372,2.336-0.297l5.391,11.206l12.347-1.473C395.75,187.136,396.433,188.583,395.571,189.407z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMo);
export default __webpack_public_path__ + "static/media/mo.3160a9b9f3404ca895014858fe0b5eb1.svg";
export { ForwardRef as ReactComponent };